// import axios from 'axios'
import axios from '../redux/axiosSetup';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { domainUrl } from '../data/dummyData';

let url = "http://127.0.0.1:8000/api"
url =  domainUrl


export const signIn = createAsyncThunk(
  'user/login',
  async (
    reqData, 
    { rejectWithValue }) => {
    try {
      // configure header's Content-Type as JSON
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      }

      const { data } = await axios.post(
        `${url}/login`,
        reqData,
        config
      )

      // store user's token in local storage
      localStorage.setItem('userToken', data.token)
      // console.log('data', data)

      return data
    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        alert('Error: '+error.response.data.message);
        return rejectWithValue(error.response.data.message)
      } else {
        alert('Error: '+error.message);
        return rejectWithValue(error.message)
      }
    }
  }
)

export const editUser= createAsyncThunk(
  'user/edit',
  async (
    reqData, 
    { getState, rejectWithValue }) => {
    try {
      const { user } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${user.userToken}`,
          'Content-Type': 'multipart/form-data',
        },
      };

      const { data } = await axios.post(
        `${url}/emy_profile_edit`,
        reqData,
        config
      )

      localStorage.setItem('userToken', data.token)

      return data.data

    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        alert('Error: '+error.response.data.message);
        return rejectWithValue(error.response.data.message)
      } else {
        alert('Error: '+error.message);
        return rejectWithValue(error.message)
      }
    }
  }
)

export const changePass= createAsyncThunk(
  'user/pass',
  async (
    reqData, 
    { getState, rejectWithValue }) => {
    try {
      const { user } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${user.userToken}`,
          'Content-Type': 'multipart/form-data',
        },
      };

      const { data } = await axios.post(
        `${url}/change_password`,
        reqData,
        config
      )

      localStorage.setItem('userToken', data.token)

      return data.data

    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        alert('Error: '+error.response.data.message);
        return rejectWithValue(error.response.data.message)
      } else {
        alert('Error: '+error.message);
        return rejectWithValue(error.message)
      }
    }
  }
)

export const signUp = createAsyncThunk(
  'user/register',
  async (
    { 
      name,
      email,
      phone,
      password,
      long,
      lat,
      voterId,
    }, 
    { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      }

      // console.log('ax', firstName)
      const { data } = await axios.post(
        `${url}/register`,
        { 
          name,
          email,
          phone,
          password,
          long,
          lat,
          voterId,
        },
        config
      )
      
      // window.location.href = "/login";
      // console.log('axd', data)
      // localStorage.setItem('userToken', data.data.token)
      // return data
      return {
        user: data.data,
        message: data.message,
        success:data.success,
        token: data.token
      }

    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const logout = createAsyncThunk(
  'user/logout',
  async (arg, { getState, rejectWithValue }) => {
    try {
      const { user } = getState();
      // console.log('User token:', user.userToken);

      const config = {
        headers: {
          Authorization: `Bearer ${user.userToken}`,
        },
      };

      const { data } = await axios.get(`${url}/logout`, config);

      localStorage.clear();

      return data;
    } catch (error) {
      localStorage.clear();
      return rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const deleteUser= createAsyncThunk(
  'user/delete',
  async (userId, { getState, rejectWithValue }) => {
    try {
      // get user data from store
      const { persist } = getState()
      
      // configure authorization header with user's token
      const config = {
        headers: {
          Authorization: `Bearer ${persist.user.userToken}`,
        },
      }

      const { data } = await axios.delete(`${url}/users/${userId}`, config)
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const deleteAccount = createAsyncThunk(
  'user/delete',
  async (arg, { getState, rejectWithValue }) => {
    try {
      // get user data from store
      const { persist } = getState()
      
      // configure authorization header with user's token
      const config = {
        headers: {
          Authorization: `Bearer ${persist.user.userToken}`,
        },
      }

      const { data } = await axios.delete(`${url}/users/${persist.user.id}`, config)
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const contact = createAsyncThunk(
  'user/contact',
  async (
    reqData, 
    { getState, rejectWithValue, }) => {
    try {

      const { user } = getState();
      // console.log('User token:', user.userToken);

      const config = {
        headers: {
          Authorization: `Bearer ${user.userToken}`,
        },
      };

      const { data } = await axios.post(
        `${url}/emy_user_contact`,
        reqData,
        config
      )
      
      return data

    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        alert('Error: '+error.response.data.message);
        return rejectWithValue(error.response.data.message)
      } else {
        alert('Error: '+error.message);
        return rejectWithValue(error.message)
      }
    }
  }
)

export const userSub = createAsyncThunk(
  'user/user_sub',
  async (arg, { getState, rejectWithValue }) => {
    try {
      // get user data from store
      const { persist } = getState()
      
      // configure authorization header with user's token
      const config = {
        headers: {
          Authorization: `Bearer ${persist.user.userToken}`,
        },
      }

      const { data } = await axios.get(`${url}/user_sub`, config)
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const getFlags = createAsyncThunk(
  'flag/flags',
  async (arg, { getState, rejectWithValue }) => {
    try {
      // get user data from store
      // const { persist } = getState()
      
      // configure authorization header with user's token
      const config = {
        headers: {
          // Authorization: `Bearer ${persist.user.userToken}`,
        },
      }

      const { data } = await axios.get(`${url}/emy_flags`, config)
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const getTeams = createAsyncThunk(
  'team/team',
  async (arg, { getState, rejectWithValue }) => {
    try {
      // get user data from store
      // const { persist } = getState()
      
      // configure authorization header with user's token
      const config = {
        headers: {
          // Authorization: `Bearer ${persist.user.userToken}`,
        },
      }

      const { data } = await axios.get(`${url}/emy_team`, config)
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)


// export const getBlogs = createAsyncThunk(
//   'blog/blogs',
//   async (arg, { getState, rejectWithValue }) => {
//     try {
//       // get user data from store
//       // const { persist } = getState()
      
//       // configure authorization header with user's token
//       const config = {
//         headers: {
//           // Authorization: `Bearer ${persist.user.userToken}`,
//         },
//       }

//       const { data } = await axios.get(`${url}/emy_blogs`, config)
//       return data
//     } catch (error) {
//       if (error.response && error.response.data.message) {
//         return rejectWithValue(error.response.data.message)
//       } else {
//         return rejectWithValue(error.message)
//       }
//     }
//   }
// )

export const getBlogs = createAsyncThunk(
  'blog/blogs',
  async ({ page = 1, fromHome = false } = {}, { rejectWithValue }) => {
    try {
      const config = {
        headers: {},
        params: {
          page,
          from_home: fromHome ? 1 : 0,
        },
      };

      const { data } = await axios.get(`${url}/emy_blogs`, config);
      
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getBlog = createAsyncThunk(
  'blog/blog',
  async (id, { getState, rejectWithValue }) => {
    try {
      // get user data from store
      // const { persist } = getState()
      
      // configure authorization header with user's token
      const config = {
        headers: {
          // Authorization: `Bearer ${persist.user.userToken}`,
        },
      }

      const { data } = await axios.get(`${url}/emy_blog/${id}`, config)
      
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const updateBlog= createAsyncThunk(
  'blog/update_blog',
  async (
    reqData, 
    { getState, rejectWithValue }) => {
    try {
      // get user data from store
      // const { persist } = getState()
      
      // configure authorization header with user's token
      const config = {
        headers: {
          // Authorization: `Bearer ${persist.user.userToken}`,
        },
        // withCredentials: true, // 👈 required for Laravel to match session/cookies
      }

      // console.log('ax', firstName)
      // const { data } = await axios.put(
      //   `${url}/emy_blog/${data.id}`,
      //   reqData,
      //   config
      // )
      

      const { data } = await axios.post(
        `${url}/emy_blog`,
        reqData,
        config
      )

      return data

    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)


export const getProjects = createAsyncThunk(
  'project/projects',
  async ({ page = 1, fromHome = false } = {}, { rejectWithValue }) => {
    try {
      const config = {
        headers: {},
        params: {
          page,
          from_home: fromHome ? 1 : 0,
        },
      };

      const { data } = await axios.get(`${url}/emy_projects`, config);
      
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
)

export const getProject = createAsyncThunk(
  'project/project',
  async (id, { getState, rejectWithValue }) => {
    try {
      // get user data from store
      // const { persist } = getState()
      
      // configure authorization header with user's token
      const config = {
        headers: {
          // Authorization: `Bearer ${persist.user.userToken}`,
        },
      }

      const { data } = await axios.get(`${url}/project/${id}`, config)
      
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const updateProject = createAsyncThunk(
  'project/update_project',
  async (reqData, { getState, rejectWithValue }) => {
    try {
      // get user data from store
      // const { persist } = getState()
      
      // configure authorization header with user's token
      const config = {
        headers: {
          // Authorization: `Bearer ${persist.user.userToken}`,
        },
      }

      const { data } = await axios.post(
        `${url}/update_project`, 
        config,
        reqData, // opr: view, likes, comment, 
      )
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const getPrograms = createAsyncThunk(
  'program/programs',
  async ({ page = 1, fromHome = false } = {}, { rejectWithValue }) => {
    try {
      const config = {
        headers: {},
        params: {
          page,
          from_home: fromHome ? 1 : 0,
        },
      };

      const { data } = await axios.get(`${url}/emy_programs`, config);
      
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
)

export const getProgram = createAsyncThunk(
  'program/program',
  async (id, { getState, rejectWithValue }) => {
    try {
      // get user data from store
      // const { persist } = getState()
      
      // configure authorization header with user's token
      const config = {
        headers: {
          // Authorization: `Bearer ${persist.user.userToken}`,
        },
      }

      const { data } = await axios.get(`${url}/emy_program/${id}`, config)
      
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const updateProgram = createAsyncThunk(
  'program/update_program',
  async (reqData, { getState, rejectWithValue }) => {
    try {
      // get user data from store
      // const { persist } = getState()
      
      // configure authorization header with user's token
      const config = {
        headers: {
          // Authorization: `Bearer ${persist.user.userToken}`,
        },
      }

      const { data } = await axios.post(
        `${url}/emy_program`,
        reqData,
        config
      )
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const getResearches = createAsyncThunk(
  'research/researches',
  async ({ page = 1, fromHome = false } = {}, { rejectWithValue }) => {
    try {
      const config = {
        headers: {},
        params: {
          page,
          from_home: fromHome ? 1 : 0,
        },
      };

      const { data } = await axios.get(`${url}/emy_researches`, config);
      
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
)

export const getPublications = createAsyncThunk(
  'research/publications',
  async ({ page = 1, fromHome = false } = {}, { rejectWithValue }) => {
    try {
      const config = {
        headers: {},
        params: {
          page,
          from_home: fromHome ? 1 : 0,
        },
      };

      const { data } = await axios.get(`${url}/emy_publications`, config);
      
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
)

export const getResearch = createAsyncThunk(
  'research/research',
  async (id, { getState, rejectWithValue }) => {
    try {
      // get user data from store
      // const { persist } = getState()
      
      // configure authorization header with user's token
      const config = {
        headers: {
          // Authorization: `Bearer ${persist.user.userToken}`,
        },
      }

      const { data } = await axios.get(`${url}/research/${id}`, config)
      
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const updateResearch = createAsyncThunk(
  'research/update_research',
  async (reqData, { getState, rejectWithValue }) => {
    try {
      // get user data from store
      // const { persist } = getState()
      
      // configure authorization header with user's token
      const config = {
        headers: {
          // Authorization: `Bearer ${persist.user.userToken}`,
        },
      }

      const { data } = await axios.post(
        `${url}/update_research`, 
        config,
        reqData, // opr: view, likes, comment, 
      )
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const getDepartments = createAsyncThunk(
  'department/departments',
  async (arg, { getState, rejectWithValue }) => {
    try {
      // get user data from store
      // const { persist } = getState()
      
      // configure authorization header with user's token
      const config = {
        headers: {
          // Authorization: `Bearer ${persist.user.userToken}`,
        },
      }

      const { data } = await axios.get(`${url}/emy_departments`, config)
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const getDepartment = createAsyncThunk(
  'department/department',
  async (id, { getState, rejectWithValue }) => {
    try {
      // get user data from store
      // const { persist } = getState()
      
      // configure authorization header with user's token
      const config = {
        headers: {
          // Authorization: `Bearer ${persist.user.userToken}`,
        },
      }

      const { data } = await axios.get(`${url}/department/${id}`, config)
      
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const updateDepartment = createAsyncThunk(
  'department/update_department',
  async (reqData, { getState, rejectWithValue }) => {
    try {
      // get user data from store
      // const { persist } = getState()
      
      // configure authorization header with user's token
      const config = {
        headers: {
          // Authorization: `Bearer ${persist.user.userToken}`,
        },
      }

      const { data } = await axios.post(
        `${url}/update_department`, 
        config,
        reqData, // opr: view, likes, comment, 
      )
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const getCountries = createAsyncThunk(
  'country/countries',
  async (arg, { getState, rejectWithValue }) => {
    try {
      // get user data from store
      // const { persist } = getState()
      
      // configure authorization header with user's token
      const config = {
        headers: {
          // Authorization: `Bearer ${persist.user.userToken}`,
        },
      }

      const { data } = await axios.get(`${url}/get_emy_countries`, config)
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const getCountry = createAsyncThunk(
  'country/country',
  async (id, { getState, rejectWithValue }) => {
    try {
      // get user data from store
      // const { persist } = getState()
      
      // configure authorization header with user's token
      const config = {
        headers: {
          // Authorization: `Bearer ${persist.user.userToken}`,
        },
      }

      const { data } = await axios.get(`${url}/emy_country/${id}`, config)
      
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const getClub = createAsyncThunk(
  'club/club',
  async (id, { getState, rejectWithValue }) => {
    try {
      // get user data from store
      // const { persist } = getState()
      
      // configure authorization header with user's token
      const config = {
        headers: {
          // Authorization: `Bearer ${persist.user.userToken}`,
        },
      }

      const { data } = await axios.get(`${url}/emy_club/${id}`, config)
      
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const updateCountry = createAsyncThunk(
  'country/update_country',
  async (reqData, { getState, rejectWithValue }) => {
    try {
      // get user data from store
      // const { persist } = getState()
      
      // configure authorization header with user's token
      const config = {
        headers: {
          // Authorization: `Bearer ${persist.user.userToken}`,
        },
      }

      const { data } = await axios.post(
        `${url}/update_country`, 
        config,
        reqData, // opr: view, likes, comment, 
      )
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const getPartners = createAsyncThunk(
  'partner/partners',
  async (arg, { getState, rejectWithValue }) => {
    try {
      // get user data from store
      // const { persist } = getState()
      
      // configure authorization header with user's token
      const config = {
        headers: {
          // Authorization: `Bearer ${persist.user.userToken}`,
        },
      }

      const { data } = await axios.get(`${url}/emy_partners`, config)
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const getBranch = createAsyncThunk(
  'branch/branch',
  async (id, { getState, rejectWithValue }) => {
    try {
      // get user data from store
      // const { persist } = getState()
      
      // configure authorization header with user's token
      const config = {
        headers: {
          // Authorization: `Bearer ${persist.user.userToken}`,
        },
      }

      const { data } = await axios.get(`${url}/emy_branch/${id}`, config)
      
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const getJobs = createAsyncThunk(
  'job/jobs',
  async (arg, { getState, rejectWithValue }) => {
    try {
      // get user data from store
      // const { persist } = getState()
      
      // configure authorization header with user's token
      const config = {
        headers: {
          // Authorization: `Bearer ${persist.user.userToken}`,
        },
      }

      const { data } = await axios.get(`${url}/emy_jobs`, config)
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const getJob = createAsyncThunk(
  'job/job',
  async (id, { getState, rejectWithValue }) => {
    try {
      // get user data from store
      // const { persist } = getState()
      
      // configure authorization header with user's token
      const config = {
        headers: {
          // Authorization: `Bearer ${persist.user.userToken}`,
        },
      }

      const { data } = await axios.get(`${url}/emy_job/${id}`, config)
      
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const applyJob= createAsyncThunk(
  'job/apply',
  async (
    reqData, 
    { getState, rejectWithValue }) => {
    try {
      const { user } = getState();
      
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${user.userToken}`,
        },
      }

      const { data } = await axios.post(
        `${url}/emy_job_application`,
        reqData,
        config
      )

      return data.data

    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const emyFormCreate= createAsyncThunk(
  'emyform/data',
  async (
    reqData, 
    { getState, rejectWithValue }) => {
    try {
      // const { persist } = getState()
      
      const config = {
        headers: {
          // Authorization: `Bearer ${persist.user.userToken}`,
          // 'Content-Type': 'multipart/form-data',
          'Content-Type': 'application/json',
        },
      }

      const { data } = await axios.post(
        `${url}/emy_create_form`,
        reqData,
        config
      )

      return data.data

    } catch (error) {
      if (error.response && error.response.data.message) {
        alert('Form creation failed: '+error.response.data.message);
        return rejectWithValue(error.response.data.message)
      } else {
        alert('Form creation failed: '+error.message);
        return rejectWithValue(error.message)
      }
    }
  }
)



export const getChats = createAsyncThunk(
  'user/get_chats',
  async (
    reqData, 
    { getState, rejectWithValue, }) => {
    try {

      const { user } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${user.userToken}`,
        },
      };

      const { data } = await axios.post(
        `${url}/emy_chats`,
        reqData,
        config
      )
      
      return data

    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        alert('Error: '+error.response.data.message);
        return rejectWithValue(error.response.data.message)
      } else {
        alert('Error: '+error.message);
        return rejectWithValue(error.message)
      }
    }
  }
)

export const createChat = createAsyncThunk(
  'user/create_chat',
  async (
    reqData, 
    { getState, rejectWithValue, }) => {
    try {

      const { user } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${user.userToken}`,
        },
      };

      const { data } = await axios.post(
        `${url}/emy_chat_start`,
        reqData,
        config
      )
      
      return data

    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        alert('Error: '+error.response.data.message);
        return rejectWithValue(error.response.data.message)
      } else {
        alert('Error: '+error.message);
        return rejectWithValue(error.message)
      }
    }
  }
)

export const submitChat = createAsyncThunk(
  'user/sent_chat',
  async (
    reqData, 
    { getState, rejectWithValue, }) => {
    try {

      const { user } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${user.userToken}`,
          'Content-Type': 'multipart/form-data',
        },
      };

      const { data } = await axios.post(
        `${url}/emy_chat_msg`,
        reqData,
        config
      )
      
      return data

    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        alert('Error: '+error.response.data.message);
        return rejectWithValue(error.response.data.message)
      } else {
        alert('Error: '+error.message);
        return rejectWithValue(error.message)
      }
    }
  }
)

export const submitCodeChat = createAsyncThunk(
  'user/sent_code_chat',
  async (
    reqData, 
    { getState, rejectWithValue, }) => {
    try {

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      };

      const { data } = await axios.post(
        `${url}/get_code_chat`,
        reqData,
        config
      )
      
      return data

    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        alert('Error: '+error.response.data.message);
        return rejectWithValue(error.response.data.message)
      } else {
        alert('Error: '+error.message);
        return rejectWithValue(error.message)
      }
    }
  }
)

export const editChat = createAsyncThunk(
  'user/sent_chat',
  async (
    reqData, 
    { getState, rejectWithValue, }) => {
    try {

      const { user } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${user.userToken}`,
          'Content-Type': 'multipart/form-data',
        },
      };

      const { data } = await axios.post(
        `${url}/emy_chat_edit`,
        reqData,
        config
      )
      
      return data

    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        alert('Error: '+error.response.data.message);
        return rejectWithValue(error.response.data.message)
      } else {
        alert('Error: '+error.message);
        return rejectWithValue(error.message)
      }
    }
  }
)

export const deleteChat = createAsyncThunk(
  'user/delete_chat',
  async (
    reqData, 
    { getState, rejectWithValue, }) => {
    try {

      const { user } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${user.userToken}`,
          'Content-Type': 'multipart/form-data',
        },
      };

      const { data } = await axios.post(
        `${url}/emy_chat_delete`,
        reqData,
        config
      )
      
      return data

    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        alert('Error: '+error.response.data.message);
        return rejectWithValue(error.response.data.message)
      } else {
        alert('Error: '+error.message);
        return rejectWithValue(error.message)
      }
    }
  }
)

export const getProfile = createAsyncThunk(
  'user/get_profile',
  async (
    reqData, 
    { getState, rejectWithValue, }) => {
    try {

      const { user } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${user.userToken}`,
        },
      };

      const { data } = await axios.post(
        `${url}/emy_profile`,
        reqData,
        config
      )
      
      return data

    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        alert('Error: '+error.response.data.message);
        return rejectWithValue(error.response.data.message)
      } else {
        alert('Error: '+error.message);
        return rejectWithValue(error.message)
      }
    }
  }
)


export const createVerification = createAsyncThunk(
  'user/create_chat',
  async (
    reqData, 
    { getState, rejectWithValue, }) => {
    try {

      const { user } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${user.userToken}`,
        },
      };

      const { data } = await axios.post(
        `${url}/emy_new_verification`,
        reqData,
        config
      )
      
      return data

    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        alert('Error: '+error.response.data.message);
        return rejectWithValue(error.response.data.message)
      } else {
        alert('Error: '+error.message);
        return rejectWithValue(error.message)
      }
    }
  }
)

export const createApp = createAsyncThunk(
  'user/create_chat',
  async (
    reqData, 
    { getState, rejectWithValue, }) => {
    try {

      const { user } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${user.userToken}`,
        },
      };

      const { data } = await axios.post(
        `${url}/emy_new_app`,
        reqData,
        config
      )
      
      return data

    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        alert('Error: '+error.response.data.message);
        return rejectWithValue(error.response.data.message)
      } else {
        alert('Error: '+error.message);
        return rejectWithValue(error.message)
      }
    }
  }
)

export const createResearch = createAsyncThunk(
  'user/create_chat',
  async (
    reqData, 
    { getState, rejectWithValue, }) => {
    try {

      const { user } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${user.userToken}`,
        },
      };

      const { data } = await axios.post(
        `${url}/emy_new_research`,
        reqData,
        config
      )
      
      return data

    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        alert('Error: '+error.response.data.message);
        return rejectWithValue(error.response.data.message)
      } else {
        alert('Error: '+error.message);
        return rejectWithValue(error.message)
      }
    }
  }
)


export const createPublication = createAsyncThunk(
  'user/create_pub',
  async (
    reqData, 
    { getState, rejectWithValue, }) => {
    try {

      const { user } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${user.userToken}`,
        },
      };

      const { data } = await axios.post(
        `${url}/emy_publication`,
        reqData,
        config
      )
      
      return data

    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        alert('Error: '+error.response.data.message);
        return rejectWithValue(error.response.data.message)
      } else {
        alert('Error: '+error.message);
        return rejectWithValue(error.message)
      }
    }
  }
)

